<span class="tag" [ngClass]="icon() ? ['tag-chip', 'status-' + status()] : [color()]">
  <ng-content></ng-content>
  @if (icon() && removable() && status() === 'selected') {
    <span class="tag-icon" data-testid="tag-remove" (click)="onRemove($event)">
      <ui-inline-svg class="tag-icon-close" [name]="'close-btn'"></ui-inline-svg>
    </span>
  }
</span>
